// Copyright (c) 2016 Deere & Company

import {
    getRequestTypes,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateOpenPartRequestsDateRangeFacet,
    updateSelectedPartRequestType
} from './facets';
import {
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
} from '../../../shared/action-creators/refine-list';
import {
    updateSearchBy,
    updateSearchQueryString
} from '../../search/action-creators/search';
import {exportToExcel} from '../../shared/action-creators/export-to-excel';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {onSearch} from '../../shared/action-creators/search';
import {readOpenPartRequests} from './open-part-requests';

export default {
    ...exportToExcelActions,
    exportToExcel,
    getRequestTypes,
    onSearch,
    readOpenPartRequests,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateOpenPartRequestsDateRangeFacet,
    updateSearchBy,
    updateSearchQueryString,
    updateSelectedPartRequestType
};



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/action-creators/index.js